import type { LucideIcon } from 'lucide-react'

interface StatCardProps {
  icon?: LucideIcon
  label: string
  value: string
  sublabel?: string
  accent?: 'emerald' | 'teal' | 'cyan' | 'amber' | 'rose' | 'slate'
  size?: 'sm' | 'lg'
}

const accentText: Record<string, string> = {
  emerald: 'text-emerald-400',
  teal: 'text-teal-400',
  cyan: 'text-cyan-400',
  amber: 'text-amber-400',
  rose: 'text-rose-400',
  slate: 'text-slate-200',
}

const accentBg: Record<string, string> = {
  emerald: 'bg-emerald-500/10 text-emerald-400',
  teal: 'bg-teal-500/10 text-teal-400',
  cyan: 'bg-cyan-500/10 text-cyan-400',
  amber: 'bg-amber-500/10 text-amber-400',
  rose: 'bg-rose-500/10 text-rose-400',
  slate: 'bg-slate-500/10 text-slate-300',
}

function StatCard({ icon: Icon, label, value, sublabel, accent = 'emerald', size = 'sm' }: StatCardProps) {
  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-4">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</span>
        {Icon ? (
          <span className={`flex h-7 w-7 items-center justify-center rounded-full ${accentBg[accent]}`}>
            <Icon className="h-3.5 w-3.5" />
          </span>
        ) : null}
      </div>
      <p className={`mt-2 truncate font-mono ${size === 'lg' ? 'text-3xl' : 'text-2xl'} font-semibold ${accentText[accent]}`}>{value}</p>
      {sublabel ? <p className="mt-1 text-xs text-slate-500">{sublabel}</p> : null}
    </div>
  )
}

export default StatCard
